import React from "react";
import { Col, Row } from "react-bootstrap";

interface TabHeaderProps {
    itemKey?: string;
    title: string;
}

export const TabHeader = ({ itemKey, title }: TabHeaderProps) => {
    return (
        <Row>
            <Col className="d-flex align-items-center">
                {itemKey != null && itemKey !== '' && (
                    <div className="item-key">
                        {itemKey}
                    </div>
                )}
                <div className="title">
                    {title}
                </div>
            </Col>
        </Row>
    );
};